module.exports = __webpack_public_path__ + "img/teacher01.781fa6dd.png";